module.exports = __webpack_public_path__ + "img/Home-Straightforward.4b7d1f01.jpg";